import { AILg, Button, CrossMd, paletteHelper, spacingHelper } from '@property.com.au/ui-kit';
import styled from 'styled-components';
import { usePcaChatModalContext } from '../../contexts/PcaChatModalContext';
import { useUserInteractionWithPcaChat } from '../../helpers/useUserInteractionWithPcaChat';

const ChatHeaderWrapper = styled.div`
  background: ${paletteHelper('backgroundPrimaryHigh')};
  height: 56px;
  width: 100%;
  padding: ${spacingHelper('extraSmall')};
  padding-left: ${spacingHelper('medium')};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid ${paletteHelper('borderSecondary')};
  border-radius: ${spacingHelper('small')} ${spacingHelper('small')} 0 0;
`;

const StyledAILg = styled(AILg)`
  color: ${paletteHelper('textBrand')};
`;

export const ChatHeader = () => {
  const { setPcaChatModalState } = usePcaChatModalContext();
  const { setUserInteracted } = useUserInteractionWithPcaChat();

  return (
    <ChatHeaderWrapper>
      <StyledAILg />
      <Button
        sizeVariant="small"
        variant="naked"
        hideLabel
        compact
        icon={<CrossMd />}
        onClick={() => {
          setPcaChatModalState(null);
          setUserInteracted();
        }}
      />
    </ChatHeaderWrapper>
  );
};
